import authServices from '@/services/auth'

const state = { currentUser: null }

const actions = {
  async fetchCurrentUser({ commit }) {
    const user = await authServices.fetchCurrentUser()

    commit('setCurrentUser', user)
  },
}

const mutations = {
  setCurrentUser(state, payload) {
    state.currentUser = payload
  },
}

const store = { namespaced: true, state, actions, mutations }

export default store
